<template>
<div class="home">
    <CustomNav :showButtons="true" :navBarTitle="'搜索'" />
    <div class='searchCont'>
        <div class='close' @click='goBack'>取消</div>
        <div class='inpBox'>
            <img class='searchIcon' src='/img/search-icon.png'></img>
            <input class='searchInp' @change='search' placeholder='搜索城市' confirm-type='search' v-model='searchVal'></input>
            <img v-if='!isEmpty' class='clearBtn' @click='clearInp' src='/img/clear.png'></img>
        </div>
    </div>
    <div class='resultCont'>
        <!-- 搜索开始 -->
        <div v-if='searhResult === true'>
            <div class='locationCont' v-for='(item,index) in aResult' :key='index'>
                <div class='locationTxt' @click="searchTargetCity(item)" v-if='item.locationTxt != ""' v-html='item.locationTxt' :lat='item.lat' :lng='item.lon' :location="item.parent_city + '市'" :cnty='item.cnty'>
                </div>
            </div>
        </div>
        <div v-if='searhResult === false'>
            <div class='notFind'>抱歉，未找到该城市 (｡•́︿•̀｡)</div>
        </div>
        <!-- 搜索结束 -->
        <div v-if='searhResult === null'>
            <!-- 定位开始 -->
            <div class='cityBox'>
                <div @click='getPositon()' class='cityItem district' :lat='currentCityCoordinate.lat' :lng='currentCityCoordinate.lng' :location='district'>
                    <img class='posImg' src='/img/pos.png'></img>{{district}}</div>
                <div @click='seeAll' class='cityItem'>全国</div>
            </div>
            <!-- 定位结束 -->
            <!-- 历史记录开始 -->
            <div v-if='hasHistory'>
                <div>
                    <div class='historyTitle'>
                        <div class='title'>历史记录</div>
                        <div class='clearHistory' @click='clearHistory'>清除</div>
                    </div>
                    <div class='box'>
                        <div class='cityItem' v-for='(item,index) in aHistoryCity' :key='index' :lat='item.lat' :lng='item.lng' :location='item.location' @click='searchTargetCity($item)'>{{item.location}}</div>
                    </div>
                </div>
            </div>
            <!-- 历史记录结束 -->
            <!-- 热门城市开始 -->
            <div class='hotCity' v-if='aHotCity !== null'>
                <div class='title'>热门城市</div>
                <div class='box'>
                    <div class='cityItem' v-for='(item,index) in aHotCity' :key='index' :lat='item.lat' :lng='item.lng' :location='item.location' @click='searchTargetCity(item)'>{{item.location}}</div>
                </div>
            </div>
            <!-- 热门城市结束 -->
        </div>
    </div>
</div>
</template>

<script>
// @ is an alias to /src
import {
    mapActions,
} from 'vuex';
import Loading from '@/components/Loading.vue';
import CustomNav from '@/components/CustomNav.vue';
import {
    fetchHotCity,
} from '@/api/getHotCity';
import {
    fetchCity,
} from '@/api/getCity';
const KEY = '73051c810cb5477198969fff0bee9ef2'; // 和风天气 appKEY 1213

export default {
    name: 'search',
    components: {
        Loading,
        CustomNav,
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
            searchVal: '',
            aResult: [],
            aHotCity: null,
            searhResult: null,
            isEmpty: true,
            isChina: true,
            currentCityCoordinate: {},
            district: '定位',
            aHistoryCity: [],
            hasHistory: null,
        };
    },
    mounted() {
        this.setHotCity();
    },
    methods: {
        ...mapActions([
            'setPosition', // 将 `this.increment()` 映射为 `this.$store.dispatch('increment')`
        ]),
        setHotCity() {
            const hotCity = localStorage.getItem('hotCity');
            if (hotCity && hotCity.length) {
                this.aHotCity = JSON.parse(hotCity);
            } else {
                fetchHotCity({}).then((response) => {
                    const oData = response.data;
                    if (oData.code == 1) {
                        this.aHotCity = oData.data;
                        localStorage.setItem('hotCity', JSON.stringify(oData.data));
                    }

                }).catch((err) => {
                    console.log(err);
                });
            }
        },
        seeAll() {
            this.setPosition({
                lat: '',
                lng: '',
                location: '全国',
            });
            this.goBack();
        },
        searchTargetCity(position) {
            const options = {
                lat: position.lat,
                lng: position.lon || position.lng,
            };
            this.setPosition(options);
            this.goBack();
        },
        search() {
            const location = this.searchVal;
            fetchCity({
                location,
                key: KEY,
                group: 'cn',
            }).then((response) => {
                if (response.status === 200) {
                    let aData = [];
                    const aResult = [];
                    if (response.data.HeWeather6[0].basic) {
                        aData = response.data.HeWeather6[0].basic;
                        for (let i = 0, l = aData.length; i < l; i++) {
                            const item = aData[i];
                            let locationTxt = '';
                            if (i === 0 || item.parent_city !== aData[i - 1].parent_city) {
                                if (item.cnty === '中国') {
                                    if (item.parent_city === item.location) {
                                        locationTxt = item.admin_area + ',' + item.parent_city + '市';
                                    } else {
                                        locationTxt = item.admin_area + ',' + item.parent_city + '市';
                                    }
                                } else {
                                    if (!item.admin_area) {
                                        locationTxt = item.cnty + ',' + item.location;
                                    } else {
                                        if (item.parent_city === item.location) {
                                            locationTxt = item.admin_area + ',' + item.parent_city + '市';
                                        } else {
                                            locationTxt = item.admin_area + ',' + item.parent_city + '市';
                                        }
                                        locationTxt = item.cnty + ',' + item.admin_area + '市';
                                    }
                                }
                                if (locationTxt.indexOf(this.searchVal) !== -1) {
                                    item.locationTxt = locationTxt.replace(new RegExp(this.searchVal, 'g'), '<i class="active">' + this.searchVal + '</i>');
                                } else {
                                    item.locationTxt = locationTxt;
                                }
                                aResult.push(item);
                            } else {
                                continue;
                            }
                        }
                    }
                    this.aResult = aResult,
                    this.searhResult = aData.length ? true : false;
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        getPositon() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((res) => {
                    this.setPosition({
                        lat: res.coords.latitude,
                        lng: res.coords.longitude,
                    });
                    this.currentCityCoordinate = {
                        lat: res.coords.latitude,
                        lng: res.coords.longitude,
                    };
                    this.searchTargetCity({
                        lat: res.coords.latitude,
                        lng: res.coords.longitude,
                    });
                }, (err) => {
                    this.searchTargetCity({
                        lat: '',
                        lng: '',
                    });
                });
            } else {
                alert('您的浏览器不支持获取定位');
            }
        },
        goBack() {
            this.$router.go(-1);
        },
    },
};
</script>
<style scoped lang="scss">
input:focus {
    border: none;
    outline: none;
}
.searchCont {
    height: 45px;
    padding: 7px 0;
    position: relative;
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
}

.inpBox {
    position: relative;
    margin-right: 60px;
    margin-left: 13px;
}

.searchIcon {
    position: absolute;
    height: 14px;
    width: 14px;
    top: 6px;
    left: 10px;
    background-size: 14px;
    box-sizing: border-box;
}

.clearBtn {
    position: absolute;
    height: 15px;
    width: 15px;
    padding: 5px;
    top: 3px;
    right: 5px;
    background-size: 14px;
    z-index: 2;
}

.searchInp {
    width: 100%;
    height: 30px;
    padding: 5px 25px 5px 32px;
    box-sizing: border-box;
    line-height: 24px;
    background: #f2f2f2;
    border-radius: 44px;
    font-size: 14px;
    color: #434343;
    -webkit-appearance: none;
    border-width: 0;
}

.close {
    float: right;
    font-size: 14px;
    color: #434343;
    width: 60px;
    line-height: 30px;
    text-align: center;
}

.locationCont {
    padding: 0 15px;
    height: 43px;
    line-height: 43px;
    font-size: 14px;
    border-bottom: 1px solid #eee;
}
/deep/.active {
    color: #50ade8;
    font-style: normal;
}
.hoverClass {
    background: #f5f5f5;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);
}

.locationTxt {
    width: 100%;
    display: inline-block;
}

.active {
    color: #50ade8;
    font-style: normal;
}

.notFind {
    margin: 70px auto 0;
    text-align: center;
    font-size: 14px;
    color: #434343;
}

.cityBox {
    padding: 13px 15px;
    font-size: 14px;
    color: #434343;
    display: flex;
}

.box {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 0 15px;
}

.cityItem {
    text-align: center;
    padding: 6px 24px;
    border-radius: 5px;
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.12);
    background: #f5f5f5;
    color: #434343;
    margin: 5px;
    font-size: 14px;
    width: 105px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: border-box;
}

.district {
    background: #F7CE3E;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px 14px;
}

.posImg {
    width: 20px;
    height: 20px;
}

.title {
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
}
.historyTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.clearHistory {
    font-size: 14px;
    padding: 0 15px;
}
</style>
